<script>
    import StudentModel from 'models/StudentModel'

    // Optional student model, to show online state
    export let model = null
    const isStudentModel = model instanceof StudentModel

    // URL to the avatar
    export let avatar = isStudentModel ? model.get('avatar') : ''

    // Label to show next to avatar, typically name
    export let label = ''

    // Style to show inside the hero (on blue background)
    export let isHero = false

    // Only show the label on hover
    export let showLabelOnHover = false

    // For students, show the dot for online state
    export let showOnlineState = true

    let isOnline = model?.get('online-state') === 'online'
    model?.listenTo(model, 'change:online-state', () => {
        isOnline = model.get('online-state') === 'online'
    })
</script>

<div class="container" class:show-label-on-hover={showLabelOnHover} class:is-hero={isHero}>
    <div
        class="holder"
        style:background-image="url('{avatar}')"
        component="avatar__holder">
        {#if isStudentModel && showOnlineState}
            <div class="online-state" class:is-online={isOnline}></div>
        {/if}
    </div>
    {#if label}
        <span class="label">{label}</span>
    {/if}
</div>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.container {
  display: inline-flex;
  align-items: center;
}
.container .holder {
  background: #fff;
  border-radius: 100%;
  width: 28px;
  height: 28px;
  background-position: center;
  background-size: cover;
  display: flex;
  position: relative; /* necessary for the online state circle on the left center */
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.1);
  flex: none;
}
.container .holder:has(.online-state) {
  margin-left: 4px;
}
.container .online-state {
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 8px;
  height: 8px;
  border-radius: 100%;
  outline: 1px solid #fff;
  background-color: #9a9bb5;
}
.container .online-state.is-online {
  background-color: #3fd17d;
}
.container .label {
  font-size: 14px;
  z-index: 9200;
  position: absolute;
  user-select: none;
  padding: 4px 8px;
  border-radius: 12px;
  color: #fff;
  background-color: #122d40;
  white-space: nowrap;
}
.container .label:empty {
  display: none;
}
.container .label {
  position: initial;
  margin-left: 8px;
}
.container.is-hero .holder {
  width: 48px;
  height: 48px;
  box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.1);
}
.container.is-hero .label {
  font-size: 26px;
  font-weight: 600;
  background: none;
}
.container.show-label-on-hover {
  position: relative;
}
.container.show-label-on-hover .label {
  display: none;
  position: absolute;
  left: 100%;
}
.container.show-label-on-hover:hover .label {
  display: block;
}</style>
